import { useMemo } from 'react';

import type { BillingAccount, CardType, Customer } from '@order/graphql';
import { useLocalizationContext } from '@order/Localization';

export const useCreditCardOptions = (
  customer: Partial<Customer>,
): readonly CreditCardOption[] => {
  const { t } = useLocalizationContext();
  const newCardLabel = t('checkout.add-card');

  const creditCardOptions = useMemo(
    () =>
      (customer?.billingAccounts?.map((billingAccount: BillingAccount) => ({
        value: billingAccount.id,
        label: `${
          billingAccount.nickname ? `${billingAccount.nickname} - ` : ''
        }${billingAccount.description}`,
        cardType: billingAccount.cardType,
      })) ?? []) as readonly CreditCardOption[],
    [customer?.billingAccounts],
  );

  return useMemo(
    () => [
      {
        value: 'ADD',
        label: newCardLabel,
        cardType: 'NEW',
      },
      ...creditCardOptions,
    ],
    [creditCardOptions, newCardLabel],
  );
};

export type CreditCardOption = {
  readonly value: string;
  readonly label: string;
  readonly cardType: CardType | 'NEW';
};
